import { IonCol, IonContent, IonGrid, IonRouterLink, IonRow, IonText } from '@ionic/react';
import React from 'react';
import { AqiStandardDto, MetricIndex, PollutantConfigDto } from '../../types';
import { Title } from '../Title';
import * as commonCss from '../../styles/common';

interface AqiInfo {
  pollutantConfigs: PollutantConfigDto[];
  aqiStandard: AqiStandardDto;
}

export const AqiInfo: React.FC<AqiInfo> = ({ pollutantConfigs, aqiStandard }) => {
  const { aqiClassType, name: metricDisplayName, aboutLink } = aqiStandard;
  return (
    <IonContent>
      <IonGrid>
        <IonRow>
          <IonCol>
            <Title level={2}>{metricDisplayName}</Title>
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol>
            <IonText css={commonCss.smallText}>
              The {aqiClassType} displayed is the maximum {aqiClassType} of all measured pollutants for the selected
              monitoring location.
            </IonText>
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol css={commonCss.smallText}>
            <ul>
              {pollutantConfigs.map(({ displayName, metricInfos }) => {
                const { aggregation } = metricInfos.find((metricInfo) => metricInfo.indexType === MetricIndex.Aqi)!;
                return (
                  <li key={displayName}>
                    {displayName} {aqiStandard.name}: based on {displayName} {aggregation} concentration
                  </li>
                );
              })}
            </ul>
          </IonCol>
        </IonRow>

        <IonRow>
          <IonCol>
            <IonRouterLink href={aboutLink} target="_blank">
              Learn more about {metricDisplayName}
            </IonRouterLink>
          </IonCol>
        </IonRow>
      </IonGrid>
    </IonContent>
  );
};
